var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBookmarkFill = function SvgBookmarkFill(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2997 2.9713C12.6397 2.9158 11.9887 3.154 11.5203 3.6224L3.59108 11.5516C2.7124 12.4303 2.7124 13.8549 3.59108 14.7336L9.60148 20.744C10.4802 21.6227 11.9048 21.6226 12.7835 20.744L20.7127 12.8148C21.181 12.3464 21.4192 11.6954 21.3638 11.0353L20.8977 5.49102C20.8057 4.39719 19.9379 3.52936 18.8441 3.43741L13.2997 2.9713ZM14.3744 9.96C14.9602 10.5458 15.9099 10.5458 16.4957 9.96C17.0815 9.37422 17.0815 8.42447 16.4957 7.83868C15.9099 7.2529 14.9602 7.2529 14.3744 7.83868C13.7886 8.42447 13.7886 9.37422 14.3744 9.96Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2997 2.9713C12.6397 2.9158 11.9887 3.154 11.5203 3.6224L3.59108 11.5516C2.7124 12.4303 2.7124 13.8549 3.59108 14.7336L9.60148 20.744C10.4802 21.6227 11.9048 21.6226 12.7835 20.744L20.7127 12.8148C21.181 12.3464 21.4192 11.6954 21.3638 11.0353L20.8977 5.49102C20.8057 4.39719 19.9379 3.52936 18.8441 3.43741L13.2997 2.9713ZM14.3744 9.96C14.9602 10.5458 15.9099 10.5458 16.4957 9.96C17.0815 9.37422 17.0815 8.42447 16.4957 7.83868C15.9099 7.2529 14.9602 7.2529 14.3744 7.83868C13.7886 8.42447 13.7886 9.37422 14.3744 9.96Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBookmarkFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bookmark-fill.17264930fa07d8d48a0b905e42eaa8ef.svg";